// Entry point for the build script in your package.json

// Responsive embeds
import responsiveEmbeds from "./frontend/responsiveEmbeds";
responsiveEmbeds();

// Grid overlay
import gridOverlay from "./frontend/gridOverlay";
gridOverlay();

// Scroll to anchors
import startScrollToAnchors from "./frontend/ScrollToAnchors";
startScrollToAnchors();

// Stimulus
import { Application } from "stimulus";
import HeaderController from "./controllers/HeaderController";
const application = Application.start();
application.register("header", HeaderController);

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);

// External links
import { startExternalLinks } from "./lib/externalLinks";
startExternalLinks();
